import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-4cd860c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "logo"
}, null, -1))
const _hoisted_2 = { class: "links-container" }
const _hoisted_3 = ["href"]

import j_links from '@/json/links.json';
import Link from '@/types/Link.type';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterSection',
  setup(__props) {

const links: Link[] = j_links.links;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    _hoisted_1,
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(links), (l, idx) => {
        return (_openBlock(), _createElementBlock("li", { key: idx }, [
          _createElementVNode("a", {
            href: l.url,
            class: "link"
          }, _toDisplayString(l.name), 9, _hoisted_3)
        ]))
      }), 128))
    ])
  ]))
}
}

})